// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RadioRow_radioRow__z4jQS {
  padding-top: 4px;
  padding-left: 4px;
  display: flex;
  margin-bottom: 4px;
  cursor: pointer;
}
@media (min-width: 1200px) {
  .RadioRow_radioRow__z4jQS {
    min-height: 33px;
    padding-top: 0;
  }
}
.RadioRow_radioRow__z4jQS input:checked + .RadioRow_radioRow__itemIco__hStL\\+, .RadioRow_radioRow__z4jQS input:checked + .RadioRow_radioRow__itemCheck__D3F6i {
  border-color: transparent;
  background-color: var(--accent-color);
}
@media (hover: hover) {
  .RadioRow_radioRow__z4jQS:hover .RadioRow_radioRow__itemIco__hStL\\+ {
    border-color: var(--accent-color);
  }
}
.RadioRow_radioRow__z4jQS:last-child {
  margin-bottom: 0;
}
.RadioRow_radioRow__itemIco__hStL\\+, .RadioRow_radioRow__itemCheck__D3F6i {
  width: 14px;
  min-width: 14px;
  height: 14px;
  border: 1px solid #D9D9D9;
  position: relative;
  margin-top: 4px;
  transition: 0.2s;
}
@media (min-width: 640px) {
  .RadioRow_radioRow__itemIco__hStL\\+, .RadioRow_radioRow__itemCheck__D3F6i {
    width: 20px;
    min-width: 20px;
    height: 20px;
    margin-top: 6px;
  }
}
@media (min-width: 1200px) {
  .RadioRow_radioRow__itemIco__hStL\\+, .RadioRow_radioRow__itemCheck__D3F6i {
    width: 14px;
    min-width: 14px;
    height: 14px;
    margin-top: 8px;
  }
}
.RadioRow_radioRow__itemIco__hStL\\+.RadioRow_error__3f9QR, .RadioRow_radioRow__itemCheck__D3F6i.RadioRow_error__3f9QR {
  border-color: #F2200D;
}
.RadioRow_radioRow__itemIco__hStL\\+ {
  border-radius: 50%;
}
.RadioRow_radioRow__itemIco__hStL\\+::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6px;
  height: 6px;
  background: #fff;
  border-radius: 50%;
}
@media (min-width: 640px) {
  .RadioRow_radioRow__itemIco__hStL\\+::before {
    width: 12px;
    height: 12px;
  }
}
@media (min-width: 1200px) {
  .RadioRow_radioRow__itemIco__hStL\\+::before {
    width: 6px;
    height: 6px;
  }
}
.RadioRow_radioRow__itemCheck__D3F6i {
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (min-width: 640px) {
  .RadioRow_radioRow__itemCheck__D3F6i {
    border-radius: 3px;
  }
}
@media (min-width: 640px) {
  .RadioRow_radioRow__itemCheck__D3F6i img {
    width: 16px;
    height: 16px;
  }
}
@media (min-width: 1200px) {
  .RadioRow_radioRow__itemCheck__D3F6i img {
    width: 12px;
    height: 12px;
  }
}
.RadioRow_radioRow__itemText__kosQP {
  margin-left: 12px;
  padding-bottom: 12px;
  border-bottom: 1px solid #efefef;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  width: 100%;
}
@media (min-width: 640px) {
  .RadioRow_radioRow__itemText__kosQP {
    margin-left: 22px;
    font-size: 20px;
    line-height: 32px;
    padding-bottom: 16px;
  }
}
@media (min-width: 1200px) {
  .RadioRow_radioRow__itemText__kosQP {
    font-size: var(--fz-md);
    line-height: var(--lh-md);
    border: none;
    padding-bottom: 0;
    padding-top: 7px;
    margin-left: 16px;
  }
}
.RadioRow_radioRow__z4jQS:last-child .RadioRow_radioRow__itemText__kosQP {
  margin-left: -18px;
  padding-left: 30px;
}
@media (min-width: 640px) {
  .RadioRow_radioRow__z4jQS:last-child .RadioRow_radioRow__itemText__kosQP {
    margin-left: -18px;
    padding-left: 40px;
  }
}
@media (min-width: 1200px) {
  .RadioRow_radioRow__z4jQS:last-child .RadioRow_radioRow__itemText__kosQP {
    padding-left: 0;
    margin-left: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Assets/RadioRow/RadioRow.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;AACF;AACE;EAPF;IAQI,gBAAA;IACA,cAAA;EAEF;AACF;AACI;EAEE,yBAAA;EACA,qCAAA;AAAN;AAIE;EAEI;IACE,iCAAA;EAHN;AACF;AAOE;EACE,gBAAA;AALJ;AAQE;EAEE,WAAA;EACA,eAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AAPJ;AASI;EAVF;IAWI,WAAA;IACA,eAAA;IACA,YAAA;IACA,eAAA;EANJ;AACF;AAQI;EAjBF;IAkBI,WAAA;IACA,eAAA;IACA,YAAA;IACA,eAAA;EALJ;AACF;AAOI;EACE,qBAAA;AALN;AASE;EACE,kBAAA;AAPJ;AASI;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AAPN;AASM;EAXF;IAYI,WAAA;IACA,YAAA;EANN;AACF;AAQM;EAhBF;IAiBI,UAAA;IACA,WAAA;EALN;AACF;AASE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAPJ;AASI;EANF;IAOI,kBAAA;EANJ;AACF;AASM;EADF;IAEI,WAAA;IACA,YAAA;EANN;AACF;AAQM;EANF;IAOI,WAAA;IACA,YAAA;EALN;AACF;AASE;EACE,iBAAA;EACA,oBAAA;EACA,gCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAPJ;AASI;EAVF;IAWI,iBAAA;IACA,eAAA;IACA,iBAAA;IACA,oBAAA;EANJ;AACF;AAQI;EAjBF;IAkBI,uBAAA;IACA,yBAAA;IACA,YAAA;IACA,iBAAA;IACA,gBAAA;IACA,iBAAA;EALJ;AACF;AAQE;EACE,kBAAA;EACA,kBAAA;AANJ;AAQI;EAJF;IAKI,kBAAA;IACA,kBAAA;EALJ;AACF;AAOI;EATF;IAUI,eAAA;IACA,iBAAA;EAJJ;AACF","sourcesContent":[".radioRow {\n  padding-top: 4px;\n  padding-left: 4px;\n  display: flex;\n  margin-bottom: 4px;\n  cursor: pointer;\n\n  @media (min-width: 1200px) {\n    min-height: 33px;\n    padding-top: 0;\n  }\n\n  input:checked {\n    & + .radioRow__itemIco,\n    & + .radioRow__itemCheck {\n      border-color: transparent;\n      background-color: var(--accent-color);\n    }\n  }\n\n  @media (hover: hover) {\n    &:hover {\n      .radioRow__itemIco {\n        border-color: var(--accent-color);\n      }\n    }\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  &__itemIco,\n  &__itemCheck {\n    width: 14px;\n    min-width: 14px;\n    height: 14px;\n    border: 1px solid #D9D9D9;\n    position: relative;\n    margin-top: 4px;\n    transition: 0.2s;\n\n    @media (min-width: 640px) {\n      width: 20px;\n      min-width: 20px;\n      height: 20px;\n      margin-top: 6px;\n    }\n\n    @media (min-width: 1200px) {\n      width: 14px;\n      min-width: 14px;\n      height: 14px;\n      margin-top: 8px;\n    }\n    \n    &.error {\n      border-color: #F2200D;\n    }\n  }\n\n  &__itemIco {\n    border-radius: 50%;\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 50%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n      width: 6px;\n      height: 6px;\n      background: #fff;\n      border-radius: 50%;\n\n      @media (min-width: 640px) {\n        width: 12px;\n        height: 12px;\n      }\n\n      @media (min-width: 1200px) {\n        width: 6px;\n        height: 6px;\n      }\n    }\n  }\n\n  &__itemCheck {\n    border-radius: 2px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    @media (min-width: 640px) {\n      border-radius: 3px;\n    }\n\n    img {\n      @media (min-width: 640px) {\n        width: 16px;\n        height: 16px;\n      }\n\n      @media (min-width: 1200px) {\n        width: 12px;\n        height: 12px;\n      }\n    }\n  }\n\n  &__itemText {\n    margin-left: 12px;\n    padding-bottom: 12px;\n    border-bottom: 1px solid #efefef;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 22px;\n    width: 100%;\n\n    @media (min-width: 640px) {\n      margin-left: 22px;\n      font-size: 20px;\n      line-height: 32px;\n      padding-bottom: 16px;\n    }\n\n    @media (min-width: 1200px) {\n      font-size: var(--fz-md);\n      line-height: var(--lh-md);\n      border: none;\n      padding-bottom: 0;\n      padding-top: 7px;\n      margin-left: 16px;\n    }\n  }\n\n  &:last-child &__itemText {\n    margin-left: -18px;\n    padding-left: 30px;\n\n    @media (min-width: 640px) {\n      margin-left: -18px;\n      padding-left: 40px;\n    }\n\n    @media (min-width: 1200px) {\n      padding-left: 0;\n      margin-left: 16px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radioRow": `RadioRow_radioRow__z4jQS`,
	"radioRow__itemIco": `RadioRow_radioRow__itemIco__hStL+`,
	"radioRow__itemCheck": `RadioRow_radioRow__itemCheck__D3F6i`,
	"error": `RadioRow_error__3f9QR`,
	"radioRow__itemText": `RadioRow_radioRow__itemText__kosQP`
};
export default ___CSS_LOADER_EXPORT___;
